import { supabase } from '../lib/supabase';

export type ReportedItemType = 'post' | 'profile' | 'comment';

export const reportsService = {
  async createReport(params: {
    itemType: ReportedItemType;
    itemId: string;
    reason: string;
    description?: string;
  }) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      throw new Error('Debes iniciar sesión para reportar contenido.');
    }

    const payload = {
      reporter_id: user.id,
      reported_item_type: params.itemType,
      reported_item_id: params.itemId,
      reason: params.reason,
      description: params.description || null,
    };

    const { data, error } = await supabase
      .from('reports')
      .insert(payload)
      .select()
      .single();

    if (error) throw error;
    return data;
  },

  async getMyReports() {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      throw new Error('No autenticado');
    }

    const { data, error } = await supabase
      .from('reports')
      .select('*')
      .eq('reporter_id', user.id)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  },
};
